import React from 'react';
import { motion } from 'framer-motion';
import { Dumbbell, UtensilsCrossed, Pill } from 'lucide-react';
const features = [{
  icon: Dumbbell,
  title: 'Protocolo Mínimo Efectivo',
  description: 'Solo 12 minutos al día: Sentadillas, Flexiones y Plancha. Sin gimnasio, sin equipamiento costoso.'
}, {
  icon: UtensilsCrossed,
  title: 'Recetario Sabor Latino',
  description: 'Pancakes de Avena, Tacos de Pescado y más. Comida deliciosa que no parece dieta porque NO es una dieta restrictiva.'
}, {
  icon: Pill,
  title: 'Suplementación Inteligente',
  description: 'Magnesio para el sueño, Vitamina D3+K2 para los huesos, Ashwagandha para control de cortisol. Solo lo esencial.'
}];
export function LifestyleSection() {
  return <section className="py-24 bg-[#F0FDF4]" data-id="element-158">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-159">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-160">
          <h2 className="text-3xl md:text-4xl font-bold text-[#064E3B] mb-6" data-id="element-161">
            Todo lo que Necesitas para tu Transformación
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-162">
          {features.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-md border border-green-100 text-center hover:shadow-lg transition-shadow duration-300" data-id="element-163">
              <div className="w-16 h-16 bg-[#ECFDF5] rounded-full flex items-center justify-center mx-auto mb-6 text-[#0D6B4F]" data-id="element-164">
                <item.icon size={32} strokeWidth={2} data-id="element-165" />
              </div>

              <h3 className="text-xl font-bold text-[#1F2937] mb-3" data-id="element-166">
                {item.title}
              </h3>
              <p className="text-[#6B7280] leading-relaxed" data-id="element-167">
                {item.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}